import { createSlice } from "@reduxjs/toolkit";
import { getNewsPosts, addNewNewsPost, updateNewsPost, deleteNewsPost } from './thunk';
import { readThunkError } from "../thunkError";

export const initialState = {
  newsposts: [],
  error: {}
};

const newsPostsSlice = createSlice({
  name: "newsposts",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getNewsPosts.pending, (state) => {
      state.isNewsPostsLoading = true;
      state.isNewsPostsSuccess = false;
    });

    builder.addCase(getNewsPosts.fulfilled, (state, action) => {
      state.newsposts = action.payload;
      state.isNewsPostsFail = false;
      state.isNewsPostsSuccess = true;
      state.isNewsPostsLoading = false;
    });

    builder.addCase(getNewsPosts.rejected, (state, action) => {
      state.error = readThunkError(action);
      state.isNewsPostsFail = true;
      state.isNewsPostsSuccess = false;
      state.isNewsPostsLoading = false;
    });

    builder.addCase(addNewNewsPost.fulfilled, (state, action) => {
      state.newsposts.push(action.payload);
      state.isNewsPostAdd = true;
      state.isNewsPostAddFail = false;
    });

    builder.addCase(addNewNewsPost.rejected, (state, action) => {
      state.error = readThunkError(action);
      state.isNewsPostAdd = false;
      state.isNewsPostAddFail = true;
    });

    builder.addCase(updateNewsPost.fulfilled, (state, action) => {
      state.newsposts = state.newsposts.map(newsposts =>
        newsposts._id.toString() === action.payload._id.toString()
          ? { ...newsposts, ...action.payload }
          : newsposts
      );
      state.isNewsPostUpdate = true;
      state.isNewsPostUpdateFail = false;
    });

    builder.addCase(updateNewsPost.rejected, (state, action) => {
      state.error = readThunkError(action);
      state.isNewsPostUpdate = false;
      state.isNewsPostUpdateFail = true;
    });

    builder.addCase(deleteNewsPost.fulfilled, (state, action) => {
      state.newsposts = (state.newsposts || []).filter((newsposts) => newsposts._id.toString() !== action.payload.newsposts.toString());

      state.isNewsPostDelete = true;
      state.isNewsPostDeleteFail = false;
    });

    builder.addCase(deleteNewsPost.rejected, (state, action) => {
      state.error = readThunkError(action);
      state.isNewsPostDelete = false;
      state.isNewsPostDeleteFail = true;
    });

  },
});

export default newsPostsSlice.reducer;